import type { FaireProductEntity } from "../../entity_types/product";

export const starter_collection_122: FaireProductEntity = {
  token: "starter_collection_122",
  type: "product",
  name: "Holiday Cocktail Box",
  brandName: "Ghia",
  imageUrl:
    "https://cdn.faire.com/fastly/1185ca6b19e75cf0ae492a163864016579a6c2be628d6a59fe844705abbb262e.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=1440&width=1440",
  priceDollars: 75,
  msrpDollars: 150,
  description: "Migrated starter collections product",
  tags: ["starter-collections"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
